var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31758 2.973C0.349124 1.76685 1.2317 0 2.76284 0H20.7372C22.2683 0 23.1509 1.76685 22.1824 2.973L15.4167 13.1111V19.4167C15.4167 19.7232 15.2635 20.0094 15.0085 20.1794L9.50848 23.846C9.22719 24.0336 8.86553 24.0511 8.56747 23.8915C8.26941 23.732 8.08334 23.4214 8.08334 23.0833V13.1111L1.31758 2.973ZM2.75432 1.83374C2.77667 1.86018 2.7975 1.88786 2.81672 1.91666L9.76247 12.3245C9.86301 12.4751 9.91667 12.6522 9.91667 12.8333V21.3705L13.5833 18.9261V12.8333C13.5833 12.6522 13.637 12.4751 13.7375 12.3245L20.6833 1.91666C20.7025 1.88786 20.7233 1.86018 20.7457 1.83374C20.7437 1.83352 20.7409 1.83333 20.7372 1.83333H2.76284C2.75915 1.83333 2.75635 1.83352 2.75432 1.83374Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.977fecf396c6357adc0b0697c8e15534.svg";
export { ForwardRef as ReactComponent };